<div class="animated fadeIn rounded">
  <div class="card">
    <div class="card-header">
      <i class="fa fa-info"></i> Devolución de Factura al crédito para la orden {{order.code}}
    </div>
    <div class="card-body">
      <pos-stepper #cdkStepper linear="true">
        <cdk-step *ngFor="let loan of loans;let i = index" [label]="'Devolver Contrato '+loan.contractNumber"
          [stepControl]="loanForms.at(i)">
          <app-return-contract-step [loan]="loan" [loanForm]="getLoanForm(i)"></app-return-contract-step>
        </cdk-step>
        <cdk-step label="Método de Devolución" [optional]="true">
          <app-return-save-step [order]="order" [loans]="loans" (doReturn)="return($event)"
            [hideCashButton]="true"></app-return-save-step>
        </cdk-step>
      </pos-stepper>
    </div>
  </div>
</div>